import React, { useState } from "react";
import { SketchPicker } from "react-color";
import "./Customiser.css"; // Import the CSS file

const ColorCustomizer = ({ colors, onColorsChange }) => {
  const [activePickerIndex, setActivePickerIndex] = useState(null); // Track which picker is open

  const handleAddColor = () => {
    onColorsChange([...colors, "#ffffff"]);
  };

  const handleDeleteColor = (indexToRemove) => {
    onColorsChange(colors.filter((_, index) => index !== indexToRemove));
  };

  const handleColorChange = (color, index) => {
    const newColors = [...colors];
    newColors[index] = color.hex; // Update the color in the array
    onColorsChange(newColors);
  };

  return (
    <div className="color-customizer">
      <div className="color-picker-container">
        {colors.map((color, index) => (
          <div key={index} className="color-picker-input-container">
            <div
              className="color-swatch"
              style={{ backgroundColor: color }}
              onClick={() => setActivePickerIndex(index)} // Open the picker
            />

            {activePickerIndex === index && (
              <div className="sketch-picker-popover">
                <div
                  className="sketch-picker-cover"
                  onClick={() => setActivePickerIndex(null)} // Close the picker
                />
                <SketchPicker color={color} onChangeComplete={(color) => handleColorChange(color, index)} />
              </div>
            )}

            <button onClick={() => handleDeleteColor(index)} className="delete-button">
              ×
            </button>
          </div>
        ))}
        <button onClick={handleAddColor} className="add-button">
          +
        </button>
      </div>
    </div>
  );
};

export default ColorCustomizer;
